<div class="modal__header">
    <div class="modal__title">
        <i class="fa-regular fa-keyboard"></i>
        Keyboard Shortcuts
    </div>
    <div class="modal__close" (click)="popup.close();">
        <i class="fas fa-times"></i>
    </div>
</div>
<div class="modal__toolbar">
    <div class="btn-group platform-toggle" role="group" aria-label="Select platform">
        <input
            type="radio"
            class="btn-check"
            name="platform"
            id="platform-windows"
            autocomplete="off"
            [checked]="platform === 'windows'"
            (change)="platform = 'windows'"
        />
        <label class="btn btn-outline-primary" for="platform-windows">Windows</label>

        <input
            type="radio"
            class="btn-check"
            name="platform"
            id="platform-mac"
            autocomplete="off"
            [checked]="platform === 'mac'"
            (change)="platform = 'mac'"
        />
        <label class="btn btn-outline-primary" for="platform-mac">Mac</label>
    </div>
</div>
<div class="modal__content">
    <div class="shortcut-section-title">Footer navigation</div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Navigate to previous tab
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>ctrl</kbd>+<kbd>page up</kbd>
            } @else {
                <kbd>cmd</kbd>+<kbd>ctrl</kbd>+<kbd>←</kbd>
            }
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Navigate to next tab
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>ctrl</kbd>+<kbd>page down</kbd>
            } @else {
                <kbd>cmd</kbd>+<kbd>ctrl</kbd>+<kbd>→</kbd>
            }
        </div>
    </div>

    <div class="shortcut-section-title">Global</div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Expand all rows in Financial Template
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Ctrl</kbd>+<kbd>Shift</kbd>+<kbd>+</kbd>
            } @else {
                <kbd>⌘</kbd>+<kbd>Shift</kbd>+<kbd>+</kbd>
            }
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Collapse all rows in Financial Template
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Ctrl</kbd>+<kbd>Shift</kbd>+<kbd>-</kbd>
            } @else {
                <kbd>⌘</kbd>+<kbd>Shift</kbd>+<kbd>-</kbd>
            }
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Undo
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Ctrl</kbd>+<kbd>Z</kbd>
            } @else {
                <kbd>⌘</kbd>+<kbd>Z</kbd>
            }
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Redo
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Ctrl</kbd>+<kbd>Shift</kbd>+<kbd>Z</kbd>
            } @else {
                <kbd>⌘</kbd>+<kbd>Shift</kbd>+<kbd>Z</kbd>
            }
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Save
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Ctrl</kbd>+<kbd>S</kbd>
            } @else {
                <kbd>⌘</kbd>+<kbd>S</kbd>
            }
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Open/close keyboard shortcuts panel
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Ctrl</kbd>+<kbd>Shift</kbd>+<kbd>K</kbd>
            } @else {
                <kbd>⌘</kbd>+<kbd>Shift</kbd>+<kbd>K</kbd>
            }
        </div>
    </div>

    <div class="shortcut-section-title">Document Details table</div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Navigate between cells
        </div>
        <div class="shortcut-keys">
            <kbd>↑</kbd> <kbd>↓</kbd> <kbd>←</kbd> <kbd>→</kbd>
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Move to next interactive element
        </div>
        <div class="shortcut-keys">
            <kbd>Tab</kbd>
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Move to previous interactive element
        </div>
        <div class="shortcut-keys">
            <kbd>Shift</kbd>+<kbd>Tab</kbd>
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            First / last cell
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Ctrl</kbd>+<kbd>Home</kbd> / <kbd>Ctrl</kbd>+<kbd>End</kbd>
            } @else {
                <kbd>⌘</kbd>+<kbd>Home</kbd> / <kbd>⌘</kbd>+<kbd>End</kbd>
            }
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Enter edit mode for focused cell
        </div>
        <div class="shortcut-keys">
            <kbd>Enter</kbd> / <kbd>F2</kbd>
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Exit edit mode and return to focused state
        </div>
        <div class="shortcut-keys">
            <kbd>Escape</kbd>
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Uncategorize focused label cell
        </div>
        <div class="shortcut-keys">
            <kbd>U</kbd>
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Show/Hide categorized items in Document Details table
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Ctrl</kbd>+<kbd>Shift</kbd>+<kbd>H</kbd>
            } @else {
                <kbd>⌘</kbd>+<kbd>Shift</kbd>+<kbd>H</kbd>
            }
        </div>
    </div>

    <div class="shortcut-section-title">Financial Template table</div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Focus first chevron in Financial Template
        </div>
        <div class="shortcut-keys">
            <kbd>Shift</kbd>+<kbd>1</kbd>
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Add manual item (when "+" focused)
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Alt</kbd>+<kbd>M</kbd>
            } @else {
                <kbd>⌥</kbd>+<kbd>M</kbd>
            }
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Add Offset Adjustment (when "+" focused)
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Alt</kbd>+<kbd>O</kbd>
            } @else {
                <kbd>⌥</kbd>+<kbd>O</kbd>
            }
        </div>
    </div>

    <div class="shortcut-section-title">Dropdown navigation</div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Navigate items in dropdown
        </div>
        <div class="shortcut-keys">
            <kbd>↑</kbd> <kbd>↓</kbd>
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Check/uncheck items in dropdown
        </div>
        <div class="shortcut-keys">
            <kbd>Space</kbd>
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Categorize selected items
        </div>
        <div class="shortcut-keys">
            <kbd>Enter</kbd>
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Close dropdown or exit menu
        </div>
        <div class="shortcut-keys">
            <kbd>Escape</kbd>
        </div>
    </div>

    <div class="shortcut-section-title">Row actions</div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Cut (selected document row)
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Ctrl</kbd>+<kbd>X</kbd>
            } @else {
                <kbd>⌘</kbd>+<kbd>X</kbd>
            }
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Copy (selected document row)
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Ctrl</kbd>+<kbd>C</kbd>
            } @else {
                <kbd>⌘</kbd>+<kbd>C</kbd>
            }
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Paste (selected document row)
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Ctrl</kbd>+<kbd>V</kbd>
            } @else {
                <kbd>⌘</kbd>+<kbd>V</kbd>
            }
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Add row below
        </div>
        <div class="shortcut-keys">
            <kbd>Ctrl</kbd>+<kbd>+</kbd>
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Invert (change sign) selected row values
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Alt</kbd>+<kbd>I</kbd>
            } @else {
                <kbd>⌥</kbd>+<kbd>I</kbd>
            }
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Add adjustment row in the document table
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Alt</kbd>+<kbd>A</kbd>
            } @else {
                <kbd>⌥</kbd>+<kbd>A</kbd>
            }
        </div>
    </div>
    <div class="shortcut-row">
        <div class="shortcut-description">
            Delete selected row
        </div>
        <div class="shortcut-keys">
            @if (platform === 'windows') {
                <kbd>Alt</kbd>+<kbd>Backspace</kbd>
            } @else {
                <kbd>⌥</kbd>+<kbd>Backspace</kbd>
            }
        </div>
    </div>
</div>

<div class="modal__footer">
    <button class="btn btn-link" (click)="popup.close();">Close</button>
</div>
